import { useChatStore } from "../../../state/chat";
import { askAboutAndReveal } from "../../../state/chatActions";
import type { MerchantSummary } from "../../../data/types";
import { fmtPct } from "./format";
import styles from "./CohortGrid.module.css";

interface CohortGridProps {
  merchants: MerchantSummary[];
  filter?: string;
}

export function CohortGrid({ merchants, filter }: CohortGridProps) {
  const pushDrillHint = useChatStore((s) => s.pushDrillHint);
  const filtered = filter
    ? merchants.filter(
        (m) =>
          m.mcc === filter ||
          m.mccDesc.toLowerCase().includes(filter.toLowerCase()) ||
          m.status.toLowerCase() === filter.toLowerCase()
      )
    : merchants;

  return (
    <div className={styles.grid}>
      {filtered.map((m) => {
        const tone =
          m.status === "Terminated"
            ? styles.terminated
            : m.status === "Warning"
              ? styles.warn
              : styles.healthy;
        return (
          <button
            key={m.id}
            type="button"
            className={`${styles.tile} ${tone}`}
            title={`drill into ${m.name}`}
            onClick={() => {
              pushDrillHint(
                `◈ pulled up ${m.name} — ${m.mccDesc} · ${fmtPct(m.fraudRatioPct)} vamp.`
              );
              askAboutAndReveal(
                `walk me through ${m.name} (${m.id}) — drift trajectory, intervention history, refund signal, and what's driving the current vamp.`,
                "intelligence",
                { kind: "merchant", merchantId: m.id }
              );
            }}
          >
            <div className={styles.tileHeader}>
              <span className={styles.name}>{m.name}</span>
              <span className={styles.mcc}>{m.mcc}</span>
            </div>
            <div className={styles.rows}>
              <div className={styles.row}>
                <span className={styles.rowLabel}>vamp</span>
                <span className={styles.rowValue}>{fmtPct(m.fraudRatioPct)}</span>
              </div>
              <div className={styles.row}>
                <span className={styles.rowLabel}>subs</span>
                <span className={styles.rowValue}>{m.subs.toLocaleString()}</span>
              </div>
              <div className={styles.row}>
                <span className={styles.rowLabel}>refund</span>
                <span className={styles.rowValue}>{fmtPct(m.refundRatePct, 2)}</span>
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
}
